import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

window.addEventListener('load', () => {
    gsap.registerPlugin(ScrollTrigger);

    const mainContent = document.querySelector('.main-content:not(.no-animation)');
    if (!mainContent) {return;}

    const sections = gsap.utils.toArray('.bg-dark-animate, .bg-light-animate');
    let sectionTriggers = [];

    const isColorDark = (color) => {
        const tempEl = document.createElement('div');
        tempEl.style.color = color;
        document.body.appendChild(tempEl);
        const computedColor = getComputedStyle(tempEl).color;
        document.body.removeChild(tempEl);

        const rgb = computedColor.match(/\d+/g).map(Number);
        const luminance = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2];
        return luminance < 128;
    };

    const applyColors = (color) => {
        const isDark = isColorDark(color);
        mainContent.style.setProperty('--bg-color-animate', color);
        mainContent.style.setProperty('--text-color', isDark ? '#ffffff' : '#030621');
    };

    const initScrollTriggers = () => {
        if (!sections.length) {return;}

        sectionTriggers.forEach(trigger => trigger.kill());
        sectionTriggers = [];

        sections.forEach((section, i) => {
            const currentColor = getComputedStyle(section).getPropertyValue('--bg-color').trim();
            const prevColor = i > 0 ?
                getComputedStyle(sections[i - 1]).getPropertyValue('--bg-color').trim() :
                currentColor;
            const triggerStart = window.innerWidth > 1920 ? 'top 33%' : 'top 55%';
            const trigger = ScrollTrigger.create({
                trigger: section,
                start: triggerStart,
                end: 'bottom center',
                markers: false,
                onEnter: () => {
                    gsap.to(mainContent, {
                        duration: 1,
                        ease: 'none',
                        onStart: () => applyColors(currentColor),
                    });
                },
                onLeaveBack: () => {
                    gsap.to(mainContent, {
                        duration: 1,
                        ease: 'none',
                        onStart: () => applyColors(prevColor),
                    });
                },
            });

            sectionTriggers.push(trigger);
        });

        ScrollTrigger.refresh();
        window.dispatchEvent(new CustomEvent('ScrollTriggersInitialized'));
    };

    const handleResponsiveTriggers = () => {
        const isLargeScreen = window.innerWidth > 991;

        sectionTriggers.forEach(trigger => trigger.kill());
        sectionTriggers = [];

        if (isLargeScreen) {
            initScrollTriggers();
        }

        requestAnimationFrame(() => {
            ScrollTrigger.refresh();
        });
    };

    handleResponsiveTriggers();

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            handleResponsiveTriggers();
        }, 200);
    });
});